<!-- <div class="text-center btn btn-info form-control "><h4 style="color: #fff;">{{adminType}}</h4></div> -->
<perfect-scrollbar *ngIf="this.flatConfig['layout'] === 'vertical'" (clickOutside)="navMob()" [excludeBeforeClick]="true" [exclude]="'#mobile-collapse'" id="nav-ps-flat-able" ngClass="flat-able-scroll" [style.max-width]="'300px'" [usePSClass]="'flat-able'" [disabled]="null">
 
  <div class="navbar-content "> 
    <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()">
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type=='group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type=='item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
  </div>


  <div class="border-top  border-bottom">
    <img src="/assets/images/calling_woman_vector.png" style="width: 94%;" class="pt-2 pb-2">
    <div class="col-12 text-center pt-2 pb-2 lead"><a href="mailto:support@odbus.in"><i class="fa fa-envelope"></i> support@odbus.in</a></div>
    <div class="col-12 text-center pt-2 pb-2 lead border-bottom "><a href="tel:9937000838"><i class="fa fa-phone"></i> 9937000838</a></div>
    <div class="col-12 text-center pt-2 pb-2 lead">
    <a href="javascript:" (click)="logout()" class="btn btn-danger btn-sm text-light"><b><i class="fas fa-sign-out-alt"></i> Logout</b></a>

    </div>
  </div>



  
  
</perfect-scrollbar>

<div *ngIf="this.flatConfig['layout'] === 'horizontal'" #navbarWrapper class="navbar-content sidenav-horizontal" id="layout-sidenav">
  <a href="javascript:" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
  <div  class="sidenav-horizontal-wrapper"><!-- add 14-4 viral -->
    <ul #navbarContent id="side-nav-horizontal" class="nav pcoded-inner-navbar sidenav-inner" (clickOutside)="fireLeave()" (mouseleave)="fireLeave()">
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type=='group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type=='item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
  </div>
  <a href="javascript:" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
</div>
